// due to difference between hub and idp between creating/updating users (e.g., id vs guid, params req. for calling api),
// the api logic and ui needs to be separated for re-usability

import React, { Fragment } from 'react'
import {
    Row,
    Col,
    Button,
    Form,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap'
import { TextField } from '@material-ui/core'
import { UtilConstant } from 'hub-utilities'
import HubNodeSelector from './HubNodeSelector'

export default class HubUserFormEx extends React.PureComponent {
    // private formRef: React.RefObject<HTMLFormElement>

    // constructor(props) {
    //   super(props)

    //   this.formRef = React.createRef()
    // }

    renderPasswordInput() {
        return (
            <TextField
                value={this.props.password1}
                name='password1'
                onChange={(e) =>
                    this.props.onChange(e, true)
                }
                type='password'
                id='userformPassword1'
                label='Password'
                error={
                    this.props.password1 !== '' &&
                    (this.props.password1.length < 6 ||
                        this.props.password1.includes(' '))
                }
                helperText={this.getPasswordValidationText()}
                required
            />
        )
    }

    validateForm = () =>
        // this.formRef.current!.checkValidity() &&
        this.getPasswordValidationText() === '' &&
        this.props.password1 === this.props.password2

    getPasswordValidationText() {
        if (this.props.password1 !== '') {
            if (this.props.password1.includes(' ')) {
                return 'Spaces cannot be used for password!'
            } else if (this.props.password1.length < 6) {
                return 'Please enter a password that is at least 6 chatacters long.'
            }
        }
        return ''
    }

    renderUserLevelRadioButtons() {
        return (
            <Fragment>
                <div className='formTitle'>User Level</div>
                <label className='radioContainer'>
                    Normal user
                    <input
                        onChange={() =>
                            this.props.onSelectAdminLevel(UtilConstant.HUB_USER_TYPE.HUB_USER)
                        }
                        checked={
                            this.props.adminLevel === UtilConstant.HUB_USER_TYPE.HUB_USER
                        }
                        value='Normal user'
                        type='radio'
                        id='userformAdminOptNormal'
                    />
                    <span className='checkmark' />
                </label>
                {this.props.userType > UtilConstant.HUB_USER_TYPE.HUB_ADMIN ? (
                    <OverlayTrigger
                        key='cantCreate'
                        placement='left'
                        overlay={
                            <Tooltip
                                id={this.props.nodeId}
                                className='adminTooltip rowActionTooltip'
                            >
                                You Have No
                                <br />
                                Permission to
                                <br />
                                Create Adminstrator
                            </Tooltip>
                        }
                    >
                        <div>
                            <label className='radioContainer'>
                                {`${this.props.nodes
                                        ? this.props.nodes.find(
                                            (node) => node.id === this.props.nodeId
                                        ).name
                                        : ''
                                    } Administrator`}
                                <input
                                    disabled
                                    onChange={() =>
                                        this.props.onSelectAdminLevel(
                                            UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN
                                        )
                                    }
                                    checked={
                                        this.props.adminLevel ===
                                        UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN
                                    }
                                    value={`${this.props.nodes
                                            ? this.props.nodes.find(
                                                (node) => node.id === this.props.nodeId
                                            ).name
                                            : ''
                                        } Administrator`}
                                    type='radio'
                                    id='userformAdminOptNode'
                                />
                                <span className='checkmark' />
                            </label>
                            <label className='radioContainer'>
                                System Administrator
                                <input
                                    disabled
                                    onChange={() =>
                                        this.props.onSelectAdminLevel(
                                            UtilConstant.HUB_USER_TYPE.HUB_ADMIN
                                        )
                                    }
                                    checked={
                                        this.props.adminLevel ===
                                        UtilConstant.HUB_USER_TYPE.HUB_ADMIN
                                    }
                                    value='System Administrator'
                                    type='radio'
                                    id='userformAdminOptHub'
                                />
                                <span className='checkmark' />
                            </label>
                        </div>
                    </OverlayTrigger>
                ) : (
                    <div>
                        <label className='radioContainer'>
                            {`${this.props.nodes
                                    ? this.props.nodes.find(
                                        (node) => node.id === this.props.nodeId
                                    ).name
                                    : ''
                                } Administrator`}
                            <input
                                onChange={() =>
                                    this.props.onSelectAdminLevel(
                                        UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN
                                    )
                                }
                                checked={
                                    this.props.adminLevel ===
                                    UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN
                                }
                                value={`${this.props.nodes
                                        ? this.props.nodes.find(
                                            (node) => node.id === this.props.nodeId
                                        ).name
                                        : ''
                                    } Administrator`}
                                type='radio'
                                id='userformAdminOptNode'
                            />
                            <span className='checkmark' />
                        </label>
                        <label className='radioContainer'>
                            System Administrator
                            <input
                                onChange={() =>
                                    this.props.onSelectAdminLevel(
                                        UtilConstant.HUB_USER_TYPE.HUB_ADMIN
                                    )
                                }
                                checked={
                                    this.props.adminLevel === UtilConstant.HUB_USER_TYPE.HUB_ADMIN
                                }
                                value='System Administrator'
                                type='radio'
                                id='userformAdminOptHub'
                            />
                            <span className='checkmark' />
                        </label>
                    </div>
                )}
            </Fragment>
        )
    }

    render() {
        return (
            <div className='HubUserForm'>
                <Form
                    // ref={this.formRef}
                    className='needs-validation burli-user-form mt-3'
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (this.validateForm()) {
                            this.props.onSubmit(e)
                        }
                    }}
                >
                    <Row>
                        <Col xs={6}>
                            <TextField
                                value={this.props.username}
                                name='username'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='text'
                                id='userformUsername'
                                label='Username'
                                required
                            >
                                <div className='invalid-feedback'>
                                    Please enter a valid username(must be unique in Hub).
                                </div>
                            </TextField>
                        </Col>
                        <Col xs={6}>
                            <TextField
                                value={this.props.email}
                                name='email'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='email'
                                id='userformEmail'
                                label='Email'
                                required
                            >
                                <div className='invalid-feedback'>
                                    Please enter a valid email address.
                                </div>
                            </TextField>
                        </Col>
                    </Row>
                    {!this.props.isUpdateUser && (
                        <Row>
                            <Col xs={6}>{this.renderPasswordInput()}</Col>
                            <Col xs={6}>
                                <TextField
                                    value={this.props.password2}
                                    name='password2'
                                    onChange={(e) =>
                                        this.props.onChange(e, true)
                                    }
                                    type='password'
                                    id='userformPassword2'
                                    label='Confirm password'
                                    // pattern={this.props.password1}
                                    error={
                                        this.props.password2 !== '' &&
                                        this.props.password1 !== this.props.password2
                                    }
                                    helperText={
                                        this.props.password2 !== '' &&
                                            this.props.password1 !== this.props.password2
                                            ? 'Passwords do not match'
                                            : ''
                                    }
                                    required
                                />{' '}
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={6}>
                            <TextField
                                value={this.props.firstName}
                                name='firstname'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='text'
                                id='userformFirstname'
                                label='First name'
                            />
                        </Col>
                        <Col xs={6}>
                            <TextField
                                value={this.props.lastName}
                                name='lastname'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='text'
                                id='userformLastname'
                                label='Last name'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <TextField
                                value={this.props.phoneNumber}
                                name='phoneNumber'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='text'
                                id='userformPhoneNumber'
                                label='Phone Number'
                            />
                        </Col>
                        <Col xs={6}>
                            <TextField
                                value={this.props.description}
                                name='description'
                                onChange={(e) =>
                                    this.props.onChange(e, false)
                                }
                                type='text'
                                id='userformDesc'
                                label='Description'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>{this.renderUserLevelRadioButtons()}</Col>
                        <Col xs={6}>
                            <HubNodeSelector
                                canModify={
                                    this.props.userType <= UtilConstant.HUB_USER_TYPE.HUB_ADMIN
                                }
                                initialNode={
                                    this.props.nodes
                                        ? this.props.nodes.find(
                                            (node) => node.id === this.props.nodeId
                                        ).name
                                        : ''
                                }
                                onHubNodeSelected={this.props.onHubNodeSelected}
                                onDefaultHubNodeSelected={this.props.onHubNodeSelected}
                                nodeId={this.props.nodeId}
                                nodes={this.props.nodes ? this.props.nodes : []}
                            />
                        </Col>
                    </Row>
                    {this.props.formError ? (
                        <div className='errorMsg'>{this.props.formError}</div>
                    ) : (
                        <Fragment />
                    )}
                    <Button
                        color='light'
                        type='submit'
                        size='sm'
                        className='float-right mr-0'
                    >
                        {this.props.isUpdateUser ? 'Save' : 'Create'}
                    </Button>
                </Form>
            </div>
        )
    }
}